export default {
      id: "Icon--chart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--chart",
      toString: function () {
        return this.url;
      }
    }